import { defineStore } from 'pinia'

const useProductAttributeStore = defineStore('productAttribute', {
  state: () => ({
    // add initial state here
  }),
  actions: {
    // add actions here
  },
})

export default useProductAttributeStore
